/**
 * Plan Order Status Enum
 */
export enum EPlanOrderStatus {
  NOT_YET = 2, // 交渉中
  DONE = 3, // 手配済
}

export enum EPlanOrderStatusLabel {
  NOT_YET = '交渉中',
  DONE = '手配済',
}

/**
 * Plan Quantity Suffix Enum
 */
export enum EPlanQuantitySuffix {
  NONE = 0, // なし
  OUT = 1, // 出
  WAIT = 2, // 待
}

export const EPlanQuantitySuffixLabel = {
  NONE: '',
  OUT: '出',
  WAIT: '待',
};

/**
 * Plan Formulation Product Type Enum
 */
export enum EPlanFormulationProductType {
  NONE = 0, // なし
  CONCRETE = 2, // 生コン
  OTHER = 3, // 他商品
}

export const EPlanFormulationProductTypeLabel = {
  CONCRETE: '生コン',
  OTHER: '他商品',
};

/**
 * Plan Vehicle Size Enum
 */
export enum EPlanVehicleSize {
  LARGE = 1, // 大型
  MEDIUM = 2, // 中型
  SMALL = 3, // 小型
  METER = 4, // m³車
  PICKUP = 5, // 引取
}

export const EPlanVehicleSizeLabel = {
  LARGE: '大型',
  MEDIUM: '中型',
  SMALL: '小型',
  METER: 'm³車',
  PICKUP: '引取',
};

/**
 * Plan Material Type Enum
 */
export enum EPlanMaterialType {
  NONE = 0,
  NO = 1, // なし
  BAG_CEMENT = 2, // 袋セメント
  MORTAR_1_1 = 3, // 1:1モルタル
  MORTAR_1_2 = 4, // 1:2モルタル
  MORTAR_1_3 = 5, // 1:3モルタル
  MORTAR_1_4 = 6, // 1:4モルタル
  SPECIAL_MORTAR = 7, // 特殊モルタル
}

export const EPlanMaterialTypeLabel = {
  NONE: '',
  NO: 'なし',
  BAG_CEMENT: '袋セメント',
  MORTAR_1_1: '1:1モルタル',
  MORTAR_1_2: '1:2モルタル',
  MORTAR_1_3: '1:3モルタル',
  MORTAR_1_4: '1:4モルタル',
  SPECIAL_MORTAR: '特殊モルタル',
};

/**
 * Plan Placing Method Enum
 */
export enum EPlanPlacingMethod {
  NONE = 0,
  PUMP_1 = 1, // ポンプ1基
  PUMP_2 = 2, // ポンプ2基
  BUCKET = 3, // バケット
  CAT = 4, // ネコ
  OTHER = 5, // その他
}

export const EPlanPlacingMethodLabel = {
  NONE: '',
  PUMP_1: 'ポンプ1基',
  PUMP_2: 'ポンプ2基',
  BUCKET: 'バケット',
  CAT: 'ネコ',
};
